import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, itemName, language = 'en' }) => {
  if (!isOpen) return null;

  const labels = {
    title: { en: 'Confirm Deletion', ar: 'تأكيد الحذف' },
    message: { 
      en: `Are you sure you want to delete "${itemName}"? This action cannot be undone.`,
      ar: `هل أنت متأكد من حذف "${itemName}"؟ هذا الإجراء لا يمكن التراجع عنه.` 
    },
    cancel: { en: 'Cancel', ar: 'إلغاء' },
    confirm: { en: 'Delete', ar: 'حذف' }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-foreground">{labels.title[language]}</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <p className="text-text-secondary mb-6">{labels.message[language]}</p>

        <div className="flex gap-3 justify-end">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
          >
            {labels.cancel[language]}
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
          >
            {labels.confirm[language]}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
